<div class="container mx-2 shadow-5 mb-3" style="border-radius: 24px;" *ngIf="profile">
    <div class="card-profile" style="padding-top: 20px;">
        @if(profile.logo.length > 0){
            <img class="w-full px-3" style="object-fit:contain; height: 125px!important; border-radius: 24px;" [src]="profile.logo" alt="">
        }@else{
            <img class="w-full px-3" style="object-fit:contain; height: 125px!important; border-radius: 24px;" src="assets/images/no_logo.jpeg" alt="">
        }
        <div class="card-profile_user-stats relative">
            <div class="grid m-0">
                <div class="col-12" style="margin-top:10px">
                    <div class="stats-holder">
                        <div class="user-stats">
                            <div class="user-infos">
                                <span class="infos_name">{{profile.businessName}}</span>
                            </div>
                        </div>
                        <div class="stats-holder flex align-items-center justify-content-center">
                            <img class="mr-3" src="https://cbn-proveedores.s3.sa-east-1.amazonaws.com/cbn-images/countries/{{profile.country | lowercase}}.png" alt="" srcset="">
                            <p-tag [value]="profile.tradeName" class="tag-info"></p-tag>
                            @if(profile.homologation === 'YES'){
                                <span class="inline-block ml-3" style="height: 24px;">
                                    <app-animated-check></app-animated-check>
                                </span>
                            }
                        </div>
                        <div class="grid mt-2">
                            <div class="col-12">
                                <div class="user-stats flex align-items-center justify-content-between">
                                    <span>
                                        <p-tag styleClass="ml-2 mr-2" severity="info" [value]="years"></p-tag>
                                    </span>
                                    <span>{{profile.codeTributary}}</span>
                                    <span>
                                        <button pButton pRipple type="button" icon="pi pi-paperclip" label="{{profile.files.length}}" class="p-button-rounded p-button-secondary mr-2 p-button-outlined" (click)="files = profile.files; opFiles.toggle($event)"></button>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="user-stats">
                                    <span>{{profile.direction}} <br> {{profile.countryName}} - {{profile.state}} - {{profile.city}}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="user-stats">
                                    <strong class="lowercase" translate>CONTACT</strong>
                                    <span>
                                        <p class="m-0">
                                            <span class="mr-2 inline-block ">
                                                <i class="fas fa-mobile-alt mr-2"></i>
                                                <span>{{profile.prefixPhone}} {{profile.phone}}</span>
                                            </span>
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="user-stats">
                                    <strong translate>comercial_activity</strong>
                                    <span class="text-center">
                                        @for (item of profile.comercialActivityList; track $index) {
                                            <p-tag styleClass="m-2" severity="success" [value]="item"></p-tag>
                                        }
                                    </span>
                                </div>
                            </div>
                            @if(profile.country === 'PE'){
                                <div class="col-12">
                                    <div class="user-stats">
                                        <strong translate>taxConditions</strong>
                                        <span class="text-center">
                                            @for (item of taxConditions; track $index) {
                                                <p-tag styleClass="m-2" severity="info" [value]="item.language_name"></p-tag>
                                            }
                                        </span>
                                    </div>
                                </div>
                            }
                            <div class="col-6">
                                <div class="user-stats">
                                    <strong translate>type_company</strong>
                                    <span>{{typeCompany}}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="user-stats">
                                    <strong translate>commercial_section</strong>
                                    <span>{{profile.commercialSectionList}}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="user-stats">
                                    <div class="social">
                                        @if(profile.web.length > 0){
                                            <a target="_blank" [href]="profile.web" class="mr-4 ">
                                                <span class="fa fa-globe text-lg"></span>
                                            </a>
                                        }
                                        @if(profile.linkedin.length > 0){
                                            <a target="_blank" [href]="profile.linkedin" class="mr-4">
                                                <span class="fab fa-linkedin text-lg"></span>
                                            </a>
                                        }
                                        @if(profile.facebook.length > 0){
                                            <a target="_blank" [href]="profile.facebook" class="">
                                                <span class="fab fa-facebook text-lg"></span>
                                            </a>
                                        }
                                    </div>
                                </div>
                            </div>
                            @if(profile.brochure.length > 0 || profile.presentationLetter.length > 0){
                                <div class="col-12">
                                    <div class="grid" style="border-top: 1px solid var(--surface-d); font-size: 11px;">
                                        @if(profile.brochure.length > 0){
                                            <div [ngClass]="{'border-set': profile.brochure.length > 0 && profile.presentationLetter.length > 0}" class="col-6 flex align-items-center justify-content-center cursor-pointer" style="margin-top: 13px;" (click)="files = profile.brochure;opFiles.toggle($event)">
                                                <span class="uppercase" translate>brochure</span>
                                                <span class="ml-2 pi pi-download"></span>
                                            </div>
                                        }
                                        @if(profile.presentationLetter.length > 0){
                                            <div class="col-6 flex align-items-center justify-content-center cursor-pointer" style="margin-top: 13px;" (click)="files = profile.presentationLetter;opFiles.toggle($event)">
                                            <span class="uppercase" translate>presentation</span><span
                                                class="ml-2 pi pi-download"></span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-overlayPanel #opFiles>
    <ng-template pTemplate>
        <app-list-files [files]="files"></app-list-files>
    </ng-template>
</p-overlayPanel>